<footer>
    <div class="container-fluid text-bg-navy text-white">
        <div class="py-4 container-xxl">
            <div class="text-start">Labcorp | {{ appName }}™ v{{ version }}</div>
        </div>
    </div>
</footer>
